// ─── Closet Build Options ─────────────────────────────────────────────────────

export const cuttingAreaOptions = [
  "Driveway",
  "Garage",
  "Balcony",
  "Backyard",
  "Parking Lot",
];

export const tearOutOptions = [
  "Standard Tear Out",
  "Additional Tear Out",
  "Baseboard Only",
  "No Tear Out",
];

export const drillOptions = ["Double Hang", "Medium Hang", "Long Hang", "Full Shelving"];

// ─── Collection & Color ───────────────────────────────────────────────────────

export const colorOptions = {
  Curated: [
    "White - L191",
    "Ivory - L204",
    "Shadows Grey - L201",
    "Summer Drops - L202",
    "Rain Cloud - L760",
    "Moonlight - L761",
    "Starry Night - L762",
    "Morning Dew - L763",
    "Daybreak - L764",
    "Midnight Sun - L765",
    "Milky Way - L767",
    "Hardrock Maple - L303",
    "Candle Light - L421",
    "Chocolate Pear Tree - L444",
    // "Truffle - L479",
    "Summer Flame - L420",
    "Prestige Maple - L476",
    "Bora Bora - L497",
    "White Chocolate - L492",
    "Winter Fun - M2004",
    "Sheer Beauty - L581",
    "Fashionista - L582",
    "Sunset Cruise - M2002",
    "After-Hours - M2010",
    "First Class - L583",
    "Free Spirit - L580",
    "Acacia Honey - L591",
    "Apres-Ski - M2015",
    "Black Karisma - L203",
    "Casting at First Light - M2007",
    "Fogo Harbour - L565",
    "Force of Nature - L830",
    "Kiss Curl - L592",
    "Latitude North - L530",
    "Latitude West - L532",
    "Love at First Sight - L590",
    "Mastermind - L593",
    "Natural Affinity - L586",
    "Rhapsody - L585",
    "Rock Solid - L831",
    "Salt of the Earth - L589",
    "Southwester - L535",
    "Spring Blossom - L543",
    "Sugar Rush - L587",
    "Summertime Blues - M2013",
    "Sunday Brunch - M2005",
    "Sweet and Savoury - L588",
    "Tea for Two - M2006",
    "Tete-a-Tete - M2001",
    "The Chameleon - L584",
    "Urban Vibe - L832",
    "Weekend Getaway - M2003",
  ],
  Designer: ["White - L191"],
  Signature: [
    "White Chocolate - L492",
    "Winter Fun - M2004",
    "Sheer Beauty - L581",
    "Fashionista - L582",
    "Sunset Cruise - M2002",
    "After-Hours - M2010",
    "First Class - L583",
    "Free Spirit - L580",
    "Acacia Honey - L591",
    "Apres-Ski - M2015",
    "Black Karisma - L203",
    "Casting at First Light - M2007",
    "Fogo Harbour - L565",
    "Force of Nature - L830",
    "Kiss Curl - L592",
    "Latitude North - L530",
    "Latitude West - L532",
    "Love at First Sight - L590",
    "Mastermind - L593",
    "Natural Affinity - L586",
    "Rhapsody - L585",
    "Rock Solid - L831",
    "Salt of the Earth - L589",
    "Southwester - L535",
    "Spring Blossom - L543",
    "Sugar Rush - L587",
    "Summertime Blues - M2013",
    "Sunday Brunch - M2005",
    "Sweet and Savoury - L588",
    "Tea for Two - M2006",
    "Tete-a-Tete - M2001",
    "The Chameleon - L584",
    "Urban Vibe - L832",
    "Weekend Getaway - M2003",
  ],
  LifeStyle: ["SP109 - Black Harmoney Texture",
    "SP109 - Black Tundra Texture",
    "SP109 - Black SuperMatte Texture",
    "SP491 - Noce Americano",
    "SP492 - Mela Rosa",
    "SP493 - Rovere Moderno",
    "SP494 - Noce Naturale ",
    "SP495 - Noce Grigia ",
    "SP496 - Noce Chiaro",
    "SP497 -  Noce Bianca",
    "SP498 - Peruvian Walnut",
    "SP499 - Tybee Oak White",
    "SP500 - Tybee Oak Natural",
    "SP501 - Mystique",
    "SP502 - Jade",
    "SP503 - Duchess",
    "SP504 - Icy Blue",
    "SP505 - Icy Green",
    "SP506 - Mountain Sage",

  ],

};
export const collectionOptions = Object.keys(colorOptions);

// ─── Doors: Series & Variants ─────────────────────────────────────────────────

export const seriesOptions = {
  Deco: ["Deco 00", "Deco 01", "Deco 70", "Deco 72", "Deco 51", "Deco 52", "Deco 83", "Deco 89"],
  "5-Piece": ["Avanti Shaker 90"],
};

export const variantOptions = {
  "Deco 00": ["Variant 100"],
  "Deco 01": ["Variant 101", "Variant 201", "Variant 301", "Variant 401"],
  "Deco 70": ["Variant 170", "Variant 270", "Variant 370", "Variant 470"],
  "Deco 72": ["Variant 172", "Variant 272", "Variant 372", "Variant 472"],
  "Deco 51": [
    "Variant 151", "Variant 155", "Variant 251", "Variant 255",
    "Variant 351", "Variant 355", "Variant 451", "Variant 455",
  ],
  "Deco 52": [
    "Variant 152", "Variant 156", "Variant 252", "Variant 256",
    "Variant 352", "Variant 356", "Variant 452", "Variant 456",
  ],
  "Deco 83": [
    "Variant 183", "Variant 193", "Variant 283", "Variant 293",
    "Variant 383", "Variant 393", "Variant 483", "Variant 493",
  ],
  "Deco 89": [
    "Variant 189", "Variant 199", "Variant 289", "Variant 299",
    "Variant 389", "Variant 399", "Variant 489", "Variant 499",
  ],
};

// ─── Doors: Grips ─────────────────────────────────────────────────────────────

export const gripoptions = ["Handle", "Knobs", "Modern Edge Pull", "Touch Latch"];

export const griptypeOptions = {
  Handle: [
    "Supplied By Customer",
    //"Standard - 20596195",
    "52003", "7348", "205", //"20576", 
    "5016", "7125", "801", "107",
    "8607", "873", "8160", "7470", "7345", "2362", "2363", "2365",
    "2368", "2570", "2576",
    // newly added — present in Accessories.xlsx but missing from the code
    "8112", "9351", "9322", "8115", "9637", "9671", "9633", "9263",
    "9636", "9781", "9300", "9303", "9550", "9664", "9311", "9561",
  ],
  Knobs: [
    "Supplied By Customer",
    //"Standard - 9041195",
    "810 ", "513 ", //"8160 ",
    "7345 ", "2363 ", "2368 ", "2570 ", "2576 ",
    "5016 ", // newly added — style 5016 also exists as a Knob in the sheet
    // newly added Knob styles from the sheet
    "8116 ", "9792 ", "9629 ", "9628 ", "9627 ", "9770 ",
  ],
  "Modern Edge Pull": ["9898", "9450", "9325"], // rebuilt — see notes above
  "Touch Latch": ["Supplied By Customer"],
};

export const gripsizeOptions = {
  // Handles
  //"Standard - 20596195": ["96mm"],
  52003: ["128mm", "160mm", "320mm"],
  7348: ["128mm", "160mm", "256mm"],
  205: ["96mm", "108mm", "128mm", "160mm", "192mm", '3"/ (Inches)'],
  //"20576": ['3"/ (Inches)'],
  5016: ["96mm", "128mm", "160mm", "192mm"],
  7125: ["96mm", "128mm", "192mm", "256mm"],
  801: ["96mm", "128mm", "160mm", "192mm", "256mm", "320mm"],
  107: ['3"/ (Inches)', '4"/ (Inches)', '6"/ (Inches)', '8"/ (Inches)'],
  8607: ["128mm"],
  873: ["96mm", "128mm", "160mm", "192mm", "224mm", "320mm"], // "320mm" added
  8160: ["96mm", "128mm", "160mm", "192mm", "320mm"], // "320mm" added
  7470: ["128mm", "160mm", "320mm"],
  7345: ["96mm", "128mm", "192mm"],
  2362: ["96mm", "128mm", "160mm", "320mm"],
  2363: ["96mm", "128mm", "160mm", "320mm"],
  2365: ["96mm", "128mm", "160mm", "320mm"],
  2368: ["96mm", "128mm", "160mm", "320mm"],
  2570: ["96mm", "128mm", "160mm", "320mm"],
  2576: ["96mm", "128mm", "160mm", "320mm"],
  // newly added Handle styles
  8112: ["128mm", "160mm", "192mm", "256mm", "320mm"],
  9351: ["96mm", "128mm", "160mm", "192mm", "256mm", "320mm"],
  9322: ["96mm", "128mm", "160mm", "192mm", "224mm", "256mm", "320mm"],
  8115: ["160mm"],
  9637: ["128mm", "192mm", "256mm"],
  9671: ["96mm", "128mm", "160mm", "192mm"],
  9633: ["96mm", "128mm", "160mm"],
  9263: ["128mm", "160mm", "256mm"],
  9636: ["96mm", "128mm", "160mm", "192mm"],
  9781: ["128mm", "160mm", "192mm", "224mm", "320mm"],
  9300: ["96mm", "160mm", "192mm"],
  9303: ["96mm", "128mm", "160mm", "192mm", "256mm", "320mm"],
  9550: ["96mm"],
  9664: ["128mm"],
  9311: ["128mm"],
  9561: ["128mm"],

  // Knobs
  //"Standard - 9041195": ["30mm", "40mm"], // "40mm" added
  "810 ": ["40mm"],
  "513 ": [//"70mm", 
    "32mm"], // ⚠ conflict — sheet says 32mm, code had 70mm; kept both, please confirm
  //"8160 ": ["32mm"],
  "7345 ": ["44mm"],
  "2363 ": ["32mm"],
  "2368 ": ["33mm"],
  "2570 ": ["38mm"],
  "2576 ": ["27mm"],
  "5016 ": ["33mm"], // newly added
  "8116 ": ["28mm"], // newly added
  "9792 ": ["32mm"], // newly added
  "9629 ": ["43mm"], // newly added
  "9628 ": ["32mm"], // newly added
  "9627 ": ["34mm"], // newly added
  "9770 ": ["31mm"], // newly added

  // Modern Edge Pull — rebuilt with real per-style sizes (see notes above)
  9898: ["40mm", "70mm", "100mm", "148mm", "436mm"],
  9450: ["38mm", "102mm", "192mm"], // newly added
  9325: ["40mm", "200mm"], // newly added
};

export const gripcolorOptions = {
  // Handles
  //"Standard - 20596195": ["Brushed Nickel"],
  52003: ["Chrome", "Matte Black", "Brushed Aurum Gold", "Brushed Nickel"],
  7348: ["Chrome", "Matte Black", "Champagne Bronze", "Brushed Nickel"],
  205: ["Chrome", "Brushed Nickel", "Matte Black", "Champagne Bronze", "Satin Brass", "Brushed Oil-Rubbed Bronze", "Matte Chrome", "Polished Copper", "Antique Nickel"],
  //20576: ["Brushed Oil-Rubbed Bronze", "Polished Copper", "Matte Chrome"],
  5016: ["Brushed Nickel", "Brushed Oil-Rubbed Bronze", "Champagne Bronze", "Matte Black", "Brushed Aurum Gold", "Matte Black / Brushed Aurum Gold"], // added combo colour
  7125: ["Brushed Nickel", "Brushed Oil-Rubbed Bronze", "Chrome"],
  801: ["Brushed Nickel", "Matte Black", "Matte Black / Brushed Nickel", "Matte Black / Chrome", "Chrome / Brushed Nickel"], // 2 added, naming aligned
  107: ["Brushed Nickel", "Chrome", "Matte Black", "Champagne Bronze"],
  8607: ["Brushed Nickel", "Brushed Oil-Rubbed Bronze"],
  873: [
    "Matte Black", "Brushed Oil-Rubbed Bronze", "Antique Nickel",
    "Champagne Bronze", "Brushed Aurum Gold", "Satin Brass",
    "Brushed Nickel", "Polished Nickel",
  ],
  8160: [
    "Brushed Aurum Gold", "Brushed Nickel", "Brushed Oil-Rubbed Bronze",
    "Champagne Bronze", "Chrome", "Matte Black", "Matte Chrome", "Satin Brass",
  ],
  7470: ["Brushed Nickel", "Matte Black", "Chrome", "Satin Brass"],
  7345: ["Brushed Nickel", "Matte Black", "Chrome", "Champagne Bronze"], // typo fixed
  2362: ["Brushed Nickel", "Matte Black", "Satin Brass", "Orion Gray"],
  2363: ["Brushed Nickel", "Matte Black", "Satin Brass", "Orion Gray"],
  2365: ["Brushed Nickel", "Matte Black", "Satin Brass", "Orion Gray"],
  2368: ["Brushed Nickel", "Matte Black", "Satin Brass", "Orion Gray"],
  2570: ["Brushed Nickel", "Orion Gray", "Matte Black", "Champagne Bronze"],
  2576: ["Brushed Nickel", "Orion Gray", "Matte Black", "Champagne Bronze"],
  // newly added Handle styles
  8112: ["Brushed Satin Nickel", "Golden Champagne", "Matte Black", "Polished Chrome"],
  9351: ["Brushed Satin Nickel", "Golden Champagne", "Matte Black", "Polished Chrome"],
  9322: ["Antique Copper Bronze", "Brushed Satin Nickel", "Golden Champagne", "Matte Black", "Polished Chrome"],
  8115: ["Brushed Satin Nickel", "Polished Chrome"],
  9637: ["Bronze Champagne", "Brushed Nickel", "Matte Black", "Polished Chrome"],
  9671: ["Brushed Satin Nickel", "Golden Champagne", "Matte Black", "Oil-Rubbed Bronze", "Polished Nickel"],
  9633: ["Antique Pewter", "Bronze Champagne", "Brushed Brass", "Brushed Nickel", "Graphite", "Matte Black", "Polished Chrome"],
  9263: ["Atomic Iron", "Brushed Nickel", "Champagne", "Matte Black", "Polished Nickel"],
  9636: ["Antique Pewter", "Bronze Champagne", "Brushed Brass", "Brushed Nickel", "Matte Black", "Polished Chrome"],
  9781: ["Champagne Gold", "Stainless Steel", "Matte Black"],
  9300: ["Brushed Nickel"],
  9303: ["Brushed Satin Nickel", "Dark Bronze", "Matte Black", "Polished Chrome", "Satin Gold"],
  9550: ["Brushed Nickel", "Matte Black"],
  9664: ["Brushed Nickel", "Matte Black"],
  9311: ["Brushed Nickel", "Matte Black"],
  9561: ["Black", "Brushed Nickel"],

  // Knobs
  //"Standard - 9041195": ["Brushed Nickel", "Matte Black", "Chrome", "Champagne Bronze", "Satin Brass"], // 4 added
  "810 ": [
    "Polished Nickel", "Brushed Nickel", "Brushed Aurum Gold",
    "Champagne Bronze", "Antique Nickel", "Brushed Oil-Rubbed Bronze",
    "Matte Black", "Satin Brass", // added
  ],
  "513 ": ["Brushed Nickel", "Champagne Bronze", "Brushed Oil-Rubbed Bronze"],
  // "8160 ": ["Brushed Aurum Gold", "Brushed Nickel", "Brushed Oil-Rubbed Bronze","Champagne Bronze", "Chrome", "Matte Black", "Matte Chrome", "Satin Brass",],
  "7345 ": ["Brushed Nickel", "Matte Black", "Chrome", "Champagne Bronze"], // typo fixed
  "2363 ": ["Brushed Nickel", "Matte Black", "Satin Brass", "Orion Gray"],
  "2368 ": ["Brushed Nickel", "Matte Black", "Satin Brass", "Orion Gray"],
  "2570 ": ["Brushed Nickel", "Orion Gray", "Matte Black", "Champagne Bronze"],
  "2576 ": ["Brushed Nickel", "Orion Gray", "Matte Black", "Champagne Bronze"],
  // newly added Knob styles
  "5016 ": ["Matte Black", "Matte Black / Brushed Aurum Gold"],
  "8116 ": ["Satin Nickel", "Polished Chrome"],
  "9792 ": ["Brushed Satin Nickel", "Dark Bronze", "Gold Champagne", "Grey", "Matte Black", "Polished Chrome", "Satin Gold"],
  "9629 ": ["Antique Pewter", "Bronze Champagne", "Brushed Brass", "Brushed Nickel", "Matte Black", "Polished Chrome"],
  "9628 ": ["Antique Pewter", "Bronze Champagne", "Brushed Brass", "Brushed Nickel", "Matte Black", "Polished Chrome"],
  "9627 ": ["Antique Pewter", "Bronze Champagne", "Brushed Brass", "Brushed Nickel", "Matte Black", "Polished Chrome"],
  "9770 ": ["Brushed Nickel", "Matte Black", "Polished Chrome"],

  // Modern Edge Pull — rebuilt (see notes above)
  9898: ["Brushed Black", "Chrome", "White", "Stainless Steel", "Aluminum", "Brushed Champagne Bronze", "Satin Gold"], // 3 added
  9450: ["Brushed Satin Nickel", "Dark Bronze", "Gold Champagne", "Matte Black", "Matte White", "Polished Chrome", "Satin Gold"],
  9325: ["Brushed Satin Nickel", "Matte Black", "Polished Chrome"],
  // touch latch 
  "supplied By Customer": [""],
};

// ─── Special Doors ────────────────────────────────────────────────────────────

export const specialDoorTypes = [
  "TFL Doors",
  "Steel Bottom Roll Mirror Sliding Door - BY0220",
  "Steel Beveled Edge Frameless Sliding Door - BY320",
  "Bottom Roll Room Divider Sliding Mirror/Glass Doors - BY7039",
  "Top Roll Sliding Mirror/Glass Insert Door - BY7041",
];

export const specialDoorSizes = {
  "TFL Doors": [
    'Up to 48" w.', 'Up to 60" w.', 'Up to 72" w.', 'Up to 84" w.', 'Up to 96" w.',
  ],
  "Steel Bottom Roll Mirror Sliding Door - BY0220": [
    'Up to 48" w.', 'Up to 60" w.', 'Up to 72" w.', 'Up to 84" w.',
    'Up to 96" w.', 'Up to 108" w.', 'Up to 120" w.', 'Up to 144" w.', 'Up to 192" w.',
  ],
  "Steel Beveled Edge Frameless Sliding Door - BY320": [
    'Up to 48" w.', 'Up to 60" w.', 'Up to 72" w.', 'Up to 84" w.',
    'Up to 96" w.', 'Up to 108" w.', 'Up to 120" w.', 'Up to 144" w.', 'Up to 192" w.',
  ],
  "Bottom Roll Room Divider Sliding Mirror/Glass Doors - BY7039": [
    '48" w. (1 Panel)', '48" w. (2 Panels)', '60" w. (1 Panel)', '60" w. (2 Panels)',
    '96" w. (2 Panels)', '108" w. (2 Panels)', '120" w. (2 Panels)', '144" w. (3 Panels)',
  ],
  "Top Roll Sliding Mirror/Glass Insert Door - BY7041": [
    '42" w.', 'Greater than 42" w. ',
  ],
};

export const specialDoorHeights = {
  "TFL Doors": ['Max Height (84")'],
  "Steel Bottom Roll Mirror Sliding Door - BY0220": ['Height 84"', 'Height 96"'],
  "Steel Beveled Edge Frameless Sliding Door - BY320": ['Height 84"', 'Height 96"'],
  "Bottom Roll Room Divider Sliding Mirror/Glass Doors - BY7039": ['Max Height (84")'],
  "Top Roll Sliding Mirror/Glass Insert Door - BY7041": ['Max Height (84")'],
};

export const specialDoorInserts = {
  "TFL Doors": ["N/A"],
  "Steel Bottom Roll Mirror Sliding Door - BY0220": [
    "Clear Mirror", "Painted White Panel", "Tinted Mirror",
  ],
  "Steel Beveled Edge Frameless Sliding Door - BY320": ["Clear Mirror"],
  "Bottom Roll Room Divider Sliding Mirror/Glass Doors - BY7039": [
    "Clear Mirror (CL)", "White Painted Glass (WPG)",
    "Clear Laminated Glass (CLG)", "White Laminated Glass (WLG)",
  ],
  "Top Roll Sliding Mirror/Glass Insert Door - BY7041": [
    "Clear Mirror (CL)", "White Painted Glass (WPG)",
    "Clear Laminated Glass (CLG)", "White Laminated Glass (WLG)",
  ],
};

export const specialDoorFrames = {
  "TFL Doors": ["N/A"],
  "Steel Bottom Roll Mirror Sliding Door - BY0220": [
    "Bright White", "Matte Black", "Arctic Silver", "Satin Nickel", "Satin Gold",
  ],
  "Steel Beveled Edge Frameless Sliding Door - BY320": [
    "Arctic Silver", "Satin Gold", "Matte Black", "Bright White",
  ],
  "Bottom Roll Room Divider Sliding Mirror/Glass Doors - BY7039": ["Anodized Black (BAE)"],
  "Top Roll Sliding Mirror/Glass Insert Door - BY7041": [
    "Clear Anodized Aluminum (A2)", "Clear Anodized Aluminum (A2)",
  ],
};

export const specialDoorEdges = {
  "TFL Doors": ["N/A"],
  "Steel Bottom Roll Mirror Sliding Door - BY0220": ["N/A"],
  "Steel Beveled Edge Frameless Sliding Door - BY320": ["Beveled Edge (B)", "Polished Edge (P)"],
  "Bottom Roll Room Divider Sliding Mirror/Glass Doors - BY7039": ["N/A"],
  "Top Roll Sliding Mirror/Glass Insert Door - BY7041": ["N/A"],
};

// ─── Rods ─────────────────────────────────────────────────────────────────────

export const rodoptions = ["Oval", "Round"];

export const rodcolorOptions = {
  Oval: ["Chrome", "Matte Nickel", "Black", "Brushed Brass"],
  Round: ["Chrome", "Matte Nickel", "Black", "Brushed Brass"],
};

// ─── Moulding ─────────────────────────────────────────────────────────────────

export const topoptions = [
  "Decorative Crown",
  "Decorative Crown To Ceiling",
  "Contemporary Riser",
  "Contemporary to Ceiling",
  "Top Accent Shelf",
];

export const bottomoptions = ["Deco Base", "Contemporary Base"];

// ─── Countertop ───────────────────────────────────────────────────────────────

export const countertopscolors = {
  TFL: [
    "White", "Antique White", "Grey", "Black", "Summer Drops",
    "Hardrock Maple", "Candlelight", "Chocolate Pear", "Winter Fun",
    "White Chocolate", "Sunset Cruise", "After Hours", "First Class",
    "Fashionista", "Sheer Beauty", "Free Spirit", "Rhapsody", "Chameleon",
  ],
  HPL: [
    "P346LM-INUKSHUK ARBON LUMINOUS", "P344LM-INUKSHUK GREY LUMINOUS",
    "P345LM-INUKSHUK TAUPE LUMINOUS", "P395VL-ARTIC ICE VELVATEX",
    "P394VL-ARTIC SNOW VELVATEX", "1890-22-SERRANIA",
    "8200K-16-WHITE DRIFTWOOD CASUAL", "4954K-22-ITALIAN WHITE DI PESCO",
    "4980K-22-PORTORO ANTIQUE", "4886-38-PEARL SOAPSTONE VELVET",
    "MW5800-EV-CALCUTTA MARBLE GLOSS", "1573-60-FROSTY WHITE MATTE",
    "8216K-28-ANTIQUE MARULA PINE GLOSS", "1879K-35 TRINDAD LAPIDUS HD MIRAGE",
    "5004-38-DUSK CASCADE FINE VELVET", "4926K-07-BLACK ALICANTE GLOSS",
    "1887-22-BENJAMIN GREY ANTIQUE", "4931-38-WHITE JUPARANA FINE VELVET",
    "WA090-NW-CANDLELIGHT NATURAL", "2002SX-BOREAL ALLURE STONEX",
    "2003SX-OCEANIC ALLURE STONEX",
  ],
  Imprezza: [
    "40001 GLT CLOUD TERRAZZON", "40261 SV CALACATTA MARBLE",
    "40477 SV BLANCO CARRARA", "40479 SV MOND MARBLE",
    "40478 SV BARMER DARK MARBLE", "40013 SV RIVIEA MERBLE",
    "40006 SV TREMBLE MARBLE", "40002 GLT CASTER TERRAZZO",
    "40294 SV CALDERA MARBLE", "40459 SV ETNA MARBLE",
    "27106 LV CHARCOAL", "27231 LV WHITE DAFFODIL", "27179 LV ANCHOR GREY",
  ],
};

export const countertops = {
  TFL: ["Curated", "Designer"],
  HPL: ["Bullnose", "Straight"],
  Imprezza: ["Straight", "Lip"],
};

// ─── Accessories: Racks ───────────────────────────────────────────────────────

export const racktypeoptions = [
  "Belt Rack - Slide and Pivoting",
  "Belt Rack",
  "Belt Rack - Pull-Out",
  "Pant and Skirt Rack",
  "Pull-Out Pant Rack",
  "Scarf Rack - Deluxe Sliding",
  "Scarf Rack",
  "Scarf Rack - Pull-Out",
  "Tie Rack - Deluxe Sliding",
  "Tie Rack",
  "Tie Rack - Pull-Out",
  "Automatic Valet Rod",
  "Closet Valet",
  "Valet Rod Design",
];

export const rackcodeoptions = {
  "Belt Rack - Slide and Pivoting": ["CSWBRSL14CR1"],
  "Belt Rack": ["807.67.211", "807.67.113"],
  "Belt Rack - Pull-Out": ["3542140", "3544140"],
  "Pant and Skirt Rack": ["PSCSL1814SCSC1", "PSCSL2414SCSC1", "PSCSL3014SCSC1"],
  "Pull-Out Pant Rack": ["805.58"],
  "Scarf Rack - Deluxe Sliding": ["CSFRSL14CR1"],
  "Scarf Rack": ["807.67.623"],
  "Scarf Rack - Pull-Out": ["3577140"],
  "Tie Rack - Deluxe Sliding": ["CTRSL14"],
  "Tie Rack": ["807.67.201", "807.67.203"],
  "Tie Rack - Pull-Out": ["3562140", "3564140"],
  "Automatic Valet Rod": ["CVLSL14"],
  "Closet Valet": ["808.70.230", "808.70.231"],
  "Valet Rod Design": ["3532140", "3531140"],
};

export const rackcolouroptions = {
  "Belt Rack - Slide and Pivoting": ["Chrome", "Matte Nickel", "Satin Nickel"],
  "Belt Rack": ["Polished Chrome", "Matte Nickel", "Black"],
  "Belt Rack - Pull-Out": ["Chrome", "Matte Black", "Matte Nickel", "Satin Brass"],
  "Pant and Skirt Rack": ["Bronze", "Satin Chrome", "Satin Nickel"],
  "Pull-Out Pant Rack": ["Polished Chrome", "Matte Nickel", "Black"],
  "Scarf Rack - Deluxe Sliding": ["Chrome", "Matte Black", "Satin Nickel"],
  "Scarf Rack": ["Polished Chrome", "Matte Nickel", "Black"],
  "Scarf Rack - Pull-Out": ["Chrome", "Matte Black", "Matte Nickel", "Satin Brass"],
  "Tie Rack - Deluxe Sliding": ["Chrome", "Matte Black", "Satin Nickel"],
  "Tie Rack": ["Polished Chrome", "Matte Nickel", "Matte Aluminum", "Black", "Matte Gold", "Slate"],
  "Tie Rack - Pull-Out": ["Polished Chrome", "Matte Nickel", "Matte Black", "Satin Brass"],
  "Automatic Valet Rod": ["Chrome", "Matte Black", "Satin Nickel"],
  "Closet Valet": ["Polished Chrome", "Matte Nickel", "Black", "Matte Aluminum", "White Powder Coated"],
  "Valet Rod Design": ["Chrome", "Matte Black", "Matte Nickel"],
};

export const racksizeoptions = {
  "Belt Rack - Slide and Pivoting": ['14"'],
  "Belt Rack": ['12"', '14"'],
  "Belt Rack - Pull-Out": ['12"', '14"'],
  "Pant and Skirt Rack": ['18" (8 Hangers)', '24" (12 Hangers)', '30" (15 Hangers)'],
  "Pull-Out Pant Rack": ['18" (12 Hangers)', '24" (18 Hangers)', '30" (24 Hangers)'],
  "Scarf Rack - Deluxe Sliding": ['14"'],
  "Scarf Rack": ['14" (6 Hooks)'],
  "Scarf Rack - Pull-Out": ['14" (6 Hooks)'],
  "Tie Rack - Deluxe Sliding": ['14"'],
  "Tie Rack": ['12" (15 Hooks)', '14" (18 Hooks)'],
  "Tie Rack - Pull-Out": ['12"', '14"'],
  "Automatic Valet Rod": ['14"'],
  "Closet Valet": ['12"', '14"'],
  "Valet Rod Design": ['12"', '14"'],
};

// ─── Accessories: Baskets ─────────────────────────────────────────────────────

export const basketTypeOptions = [
  "Polished Chrome Pull-Out Baskets (Hafele)",
  "Wire Basket - Matte Nickel (Richelieu)",
  "Wire Basket - Chrome (Richelieu)",
  "Wire Basket - Matte Black (Richelieu)",
];

export const basketSizeOptions = {
  "Polished Chrome Pull-Out Baskets (Hafele)": [
    '18"W x 12"D x 06"H / 547.38.212 (12" Deep)',
    '18"W x 12"D x 11"H / 547.38.212 (12" Deep)',
    '18"W x 12"D x 17"H / 547.38.212 (12" Deep)',
    '24"W x 12"D x 06"H / 547.38.212 (12" Deep)',
    '24"W x 12"D x 11"H / 547.38.212 (12" Deep)',
    '24"W x 12"D x 17"H / 547.38.212 (12" Deep)',
    '30"W x 12"D x 06"H / 547.38.212 (12" Deep)',
    '30"W x 12"D x 11"H / 547.38.212 (12" Deep)',
    '30"W x 12"D x 17"H / 547.38.212 (12" Deep)',
    '18"W x 16"D x 06"H / 547.38.258 (16" Deep)',
    '18"W x 16"D x 11"H / 547.38.258 (16" Deep)',
    '18"W x 16"D x 17"H / 547.38.258 (16" Deep)',
    '24"W x 16"D x 06"H / 547.38.258 (16" Deep)',
    '24"W x 16"D x 11"H / 547.38.258 (16" Deep)',
    '24"W x 16"D x 17"H / 547.38.258 (16" Deep)',
    '30"W x 16"D x 06"H / 547.38.258 (16" Deep)',
    '30"W x 16"D x 11"H / 547.38.258 (16" Deep)',
    '30"W x 16"D x 17"H / 547.38.258 (16" Deep)',
  ],
  "Wire Basket - Matte Nickel (Richelieu)": [
    '18"W x 14"D x 06"H / 8561814184',
    '18"W x 14"D x 11"H / 8511814184',
    '18"W x 14"D x 17"H / 8571814184',
    '24"W x 14"D x 06"H / 8562414184',
    '24"W x 14"D x 11"H / 8512414184',
    '24"W x 14"D x 17"H / 8572414184',
    '30"W x 14"D x 06"H / 8563014184',
    '30"W x 14"D x 11"H / 8513014184',
    '30"W x 14"D x 17"H / 8573014184',
  ],
  "Wire Basket - Chrome (Richelieu)": [
    '18"W x 14"D x 06"H / 8561814140',
    '18"W x 14"D x 11"H / 8511814140',
    '18"W x 14"D x 17"H / 8571814140',
    '24"W x 14"D x 06"H / 8562414140',
    '24"W x 14"D x 11"H / 8512414140',
    '24"W x 14"D x 17"H / 8572414140',
    '30"W x 14"D x 06"H / 8563014140',
    '30"W x 14"D x 11"H / 8513014140',
    '30"W x 14"D x 17"H / 8573014140',
  ],
  "Wire Basket - Matte Black (Richelieu)": [
    '18"W x 14"D x 06"H / 8561814900',
    '18"W x 14"D x 11"H / 8511814900',
    '18"W x 14"D x 17"H / 8571814900',
    '24"W x 14"D x 06"H / 8562414900',
    '24"W x 14"D x 11"H / 8512414900',
    '24"W x 14"D x 17"H / 8572414900',
    '30"W x 14"D x 06"H / 8563014900',
    '30"W x 14"D x 11"H / 8513014900',
    '30"W x 14"D x 17"H / 8573014900',
  ],
};

export const basketLinerOptions = {
  "Polished Chrome Pull-Out Baskets (Hafele)": [
    "Plastic Liner for Baskets (Hafele)",
    "Canvas Liner for Basket (Hafele)",
    "No Liner",
  ],
  "Wire Basket - Matte Nickel (Richelieu)": ["Plastic Liner for Basket (Richelieu)", "No Liner"],
  "Wire Basket - Chrome (Richelieu)": ["Plastic Liner for Basket (Richelieu)", "No Liner"],
  "Wire Basket - Matte Black (Richelieu)": ["Plastic Liner for Basket (Richelieu)", "No Liner"],
};

export const basketLinerSizeOptions = {
  "Plastic Liner for Baskets (Hafele)": [
    '18"W x 12"D x 06"H / 547.98.452',
    '18"W x 12"D x 11"H / 547.98.443',
    '18"W x 12"D x 17"H / 547.98.441',
    '18"W x 16"D x 06"H / 547.98.472',
    '18"W x 16"D x 11"H / 547.98.461',
    '18"W x 16"D x 17"H / 547.98.461',
    '24"W x 12"D x 06"H / 547.98.454',
    '24"W x 12"D x 11"H / 547.98.443',
    '24"W x 12"D x 17"H / 547.98.443',
    '24"W x 16"D x 06"H / 547.98.474',
    '24"W x 16"D x 11"H / 547.98.463',
    '18"W x 16"D x 17"H / 547.98.463',
    '30"W x 12"D x 06"H / 547.98.456',
    '30"W x 12"D x 11"H / 547.98.445',
    '30"W x 12"D x 17"H / 547.98.445',
    '30"W x 16"D x 06"H / 547.98.476',
    '30"W x 16"D x 11"H / 547.98.465',
    '30"W x 16"D x 17"H / 547.98.465',
  ],
  "Canvas Liner for Basket (Hafele)": [
    '18"W x 12"D x 06"H / 547.35.484',
    '18"W x 12"D x 11"H / 547.35.485',
    '18"W x 12"D x 17"H / 547.35.486',
    '18"W x 16"D x 06"H / 547.35.487',
    '18"W x 16"D x 11"H / 547.35.488',
    '18"W x 16"D x 17"H / 547.35.489',
    '24"W x 12"D x 06"H / 547.36.484',
    '24"W x 12"D x 11"H / 547.36.485',
    '24"W x 12"D x 17"H / 547.36.486',
    '24"W x 16"D x 06"H / 547.36.487',
    '24"W x 16"D x 11"H / 547.36.488',
    '24"W x 16"D x 17"H / 547.36.489',
    '30"W x 12"D x 06"H / 547.37.484',
    '30"W x 12"D x 11"H / 547.37.485',
    '30"W x 12"D x 17"H / 547.37.486',
    '30"W x 16"D x 06"H / 547.37.487',
    '30"W x 16"D x 11"H / 547.37.488',
    '30"W x 16"D x 17"H / 547.37.489',
  ],
  "Plastic Liner for Basket (Richelieu)": [
    '18"W x 14"D x 06"H / 0618011',
    '18"W x 14"D x 11"H / 1118011',
    '24"W x 14"D x 06"H / 0624011',
    '24"W x 14"D x 11"H / 1124011',
    '30"W x 14"D x 06"H / 0630011',
    '30"W x 14"D x 11"H / 1130011',
    '18"W x 14"D x 06"H / 061814034',
    '18"W x 14"D x 11"H / 111814034',
    '18"W x 14"D x 17"H / 171814034',
    '24"W x 14"D x 06"H / 062414034',
    '24"W x 14"D x 11"H / 112414034',
    '24"W x 14"D x 17"H / 172414034',
    '30"W x 14"D x 06"H / 063014034',
    '30"W x 14"D x 11"H / 113014034',
    '30"W x 14"D x 17"H / 173014034',
  ],
};

// ─── Accessories: Hooks ───────────────────────────────────────────────────────

export const hookTypeOptions = [
  "Purse Hook - RH888481",
  "Horizontal Multihook - RH888451",
  "Multi Function Hook - RH888461",
  "Ladder Hook - RH888471",
  "Double Hook - RH775232",
  "Coat Hook - 807.69.230",
  "Double Hook - 807.68.340",
  "Belt Hook - 807.69.020",
  "Tie Hook - 807.69.901",
  "Broom Hook - 807.69.050",
];

export const hookColourOptions = {
  "Purse Hook - RH888481": ["Chrome", "Brushed Nickel", "Matte Black", "Satin Brass"],
  "Horizontal Multihook - RH888451": ["Chrome", "Brushed Nickel", "Matte Black", "Satin Brass"],
  "Multi Function Hook - RH888461": ["Chrome", "Brushed Nickel", "Matte Black", "Satin Brass"],
  "Ladder Hook - RH888471": ["Chrome", "Brushed Nickel", "Matte Black", "Satin Brass"],
  "Double Hook - RH775232": ["Chrome", "Brushed Nickel", "Matte Black", "Satin Brass"],
  "Coat Hook - 807.69.230": ["Polished Chrome", "Matte Nickel", "Matte Aluminum", "Black", "Slate", "Matte Gold"],
  "Double Hook - 807.68.340": ["Polished Chrome", "Matte Nickel", "Matte Aluminum", "Black", "Slate", "Matte Gold"],
  "Belt Hook - 807.69.020": ["Polished Chrome", "Matte Nickel", "Matte Aluminum", "Black", "Slate", "Matte Gold"],
  "Tie Hook - 807.69.901": ["Polished Chrome", "Matte Nickel", "Matte Aluminum", "Black", "Slate", "Matte Gold"],
  "Broom Hook - 807.69.050": ["Polished Chrome", "Matte Nickel", "Matte Aluminum", "Black", "Slate", "Matte Gold"],
};

// ─── Accessories: Hampers ─────────────────────────────────────────────────────

export const hamperTypeOptions = [
  "Tilt-Out Hamper",
  "Pull-Out Hamper",
  "Black Pullout Hamper",
  "Tilt-Out Hamper Basket with Lining",
];

export const hamperCodeOptions = {
  "Tilt-Out Hamper": ["547.43.315"],
  "Pull-Out Hamper": ["807.52.333"],
  "Black Pullout Hamper": ["CSOHSL181", "CSOHSL241", "CSOHSL301"],
  "Tilt-Out Hamper Basket with Lining": ["CTOHSL181", "CTOHSL241", "CTOHSL301"],
};

export const hamperColourOptions = {
  "Tilt-Out Hamper": ["Black Nylon Bag"],
  "Pull-Out Hamper": ["Black Nylon Bag", "Polished Chrome Frame", "Matte Nickel Frame", "Black Frame"],
  "Black Pullout Hamper": ["No Colour Type Available"],
  "Tilt-Out Hamper Basket with Lining": ["No Colour Type Available"],
};

export const hamperSizeOptions = {
  "Tilt-Out Hamper": ['18" (1 Bag)', '24" (2 Bags)', '30" (s Bags)'],
  "Pull-Out Hamper": ['18" (1 Bag)', '24" (2 Bags)', '30" (s Bags)'],
  "Black Pullout Hamper": ['18" (1 Bag)', '24" (2 Bags)', '30" (s Bags)'],
  "Tilt-Out Hamper Basket with Lining": ['18"', '24"', '30"'],
};
